export default "__VITE_ASSET__ab73f21e__"